import { api } from '../lib/api';

export interface Apiary {
  id: number;
  name: string;
  address1: string | null;
  address2: string | null;
  postalCode: string | null;
  city: string | null;
  markagare: string | null;
  kontaktinfo: string | null;
  country: string;
  lat: string | null;
  lng: string | null;
  notes: string | null;
  todoNotes: string | null;
  isActive: number;
  activeHiveCount: number;
  inactiveHiveCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface ApiaryPayload {
  name: string;
  address1?: string;
  address2?: string;
  postalCode?: string;
  city?: string;
  markagare?: string;
  kontaktinfo?: string;
  lat?: number | null;
  lng?: number | null;
  notes?: string;
  todoNotes?: string;
}

export interface ApiaryHiveLogPayload {
  logDate?: string;
  eventType: string;
  isTreatment?: boolean;
  preparationProductId?: number;
  preparation?: string;
  withdrawalDays?: number;
  notes?: string;
}

export const apiariesApi = {
  list: (q?: string) =>
    api.get<{ apiaries: Apiary[] }>(q ? `/apiaries?q=${encodeURIComponent(q)}` : '/apiaries'),
  get: (id: number) => api.get<Apiary>(`/apiaries/${id}`),
  create: (payload: ApiaryPayload) => api.post<{ id: number }>('/apiaries', payload),
  update: (id: number, payload: Partial<ApiaryPayload>) => api.patch<{ ok: boolean }>(`/apiaries/${id}`, payload),
  remove: (id: number) => api.delete<{ ok: boolean; action?: 'hidden' | 'deleted'; message?: string }>(`/apiaries/${id}`),
  createHiveLogs: (id: number, payload: ApiaryHiveLogPayload) =>
    api.post<{ ok: boolean; createdCount: number; logIds: number[]; message?: string }>(`/apiaries/${id}/logs`, payload),
};
